import { RESET_MY_WAITROSE_REQUEST_ERROR } from 'redux/modules/mywaitrose/actions/types';

export const resetMyWaitroseRequestError = (): WtrThunkAction => dispatch =>
  dispatch({
    type: RESET_MY_WAITROSE_REQUEST_ERROR,
  });
